var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/cat.svg"),"height":"150","width":"150"}}),_c('shogi-board',{attrs:{"pageTitle":"AlphaSho"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }